export default __webpack_public_path__ + "6f4d26aaecc7ad8b4c319ed07a0d0c92.png";